export default __webpack_public_path__ + "static/media/m2_exercise.2b88d0c7.png";